import React from 'react'
import { useNavigate } from 'react-router-dom';
import './Nav.css'
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';

const Nav = () => {
    const navigate=useNavigate();
    function GoHome(){
        navigate('/hero');
    }
    function GoToFilter(){
        navigate('/filter');
    }
    function GoToProperties(){
        navigate('/filter');
    }
    function GoToForm(){
        navigate('/form');
    }
    function GoToChat(){
        navigate('/chat');
    }
    function GoToOrders(){
        navigate('/orders');
    }
    function GoToGrievance(){
        navigate('/grievance');
    }
    function GoToCalci(){
        navigate("/calci");
    }
    function GoToArVr(){
        navigate("/artour");
    }
    function GoToAgent(){
        navigate("/agent");
    }
    function GoToAgentChat(){
        navigate("/chatagent");
    }

  return (
    <div>
          <div className="Navbar">
            <span className="logo" onClick={GoHome}>Property</span>
            <span className="NavbarCenter">
                <ul className="NavbarCenterList">
                    <li  onClick={GoHome}>How</li>
                    <li  onClick={GoToProperties}>Buy</li>
                    <li  onClick={GoToForm}>Sell</li>
                    <li  onClick={GoToChat}>Chats</li>
                    <li  onClick={GoToOrders}>Orders</li>
                    <li  onClick={GoToGrievance}>Grievances</li>
                    <li  onClick={GoToCalci}>Mortgage</li>
                    <li  onClick={GoToArVr}>360° Tour</li>

                    <li  onClick={GoToAgent}>Agent</li>
                    <li  onClick={GoToAgentChat}>Agent Chat</li>
                    <li  onClick={GoToOrders} style={{"marginTop":"-0.5%"}}><AccountCircleTwoToneIcon /></li>

                </ul>
            </span>
            <span className="NavbarRight">
                <button className="NavbarRightButton">
                    Contact Us
                </button>
            </span>
        </div>
    </div>
  )
}

export default Nav